import { OrdersState, OrdersType } from "@app/modules/orders/entities/orders.entities";
import * as OrdersAction from "@app/modules/orders/store/actions/orders.action";
import { PickingPoint } from "@core/entities";
import { GlobalAdapter } from "@core/store/adapters/global.adapter";
import { EntityAdapter, EntityState, createEntityAdapter } from "@ngrx/entity";
import { Action, createFeatureSelector, createReducer, createSelector, on } from "@ngrx/store";

export const ordersPerPage: number = 50;

interface ReducerState extends OrdersState, EntityState<PickingPoint> {}

function ppAdapterSelectId(pp: PickingPoint): number {
  return pp.id;
}

export const ppAdapter: EntityAdapter<PickingPoint> = createEntityAdapter<PickingPoint>({
  selectId: ppAdapterSelectId,
  sortComparer: (ppA, ppB) => (ppA.id > ppB.id ? 1 : -1),
});

const initialState: ReducerState = ppAdapter.getInitialState({
  selectedOrder: null,
  ui: {
    loaderBtnCancel: false,
    loadingOrderDetail: false,
    loadingOrderList: false,
    loadingExcelExport: false,
    isModalCancelShow: false,
    loaderBtn: false,
    isLoading: true,
    hasData: false,
    isForm: false,
    deleteSuccess: false,
    lastArchivedOrdersPage: false,
    openExcelDialog: false,
    openColumnSettingsDialog: false,
    columns: [],
    orderBy: null,
  },
  searchInput: "",
  activeOrdersList: [],
  archivedOrdersList: [],
  ordersType: OrdersType.ACTIVE,
} as OrdersState);

const ordersReducer = createReducer(
  initialState,
  on(OrdersAction.clearAllActiveOrders, () => initialState),
  on(OrdersAction.setOrderSelected, (state, { payload }) => ({ ...state, selectedOrder: payload })),
  on(OrdersAction.setActiveOrdersList, (state, { payload }) => ({ ...state, activeOrdersList: payload })),
  on(OrdersAction.setArchivedOrdersList, (state, { payload }) => ({ ...state, archivedOrdersList: payload })),
  on(OrdersAction.setPickingPointsForOrders, (state, { payload }) => ppAdapter.setAll(payload, state)),
  on(OrdersAction.toggleOrdersType, (state, { payload }) => ({ ...state, ordersType: payload, searchInput: "" })),
  on(OrdersAction.uiOrders, (state, { ui }) => GlobalAdapter.setUi(ui, state)),
  on(OrdersAction.inputSearch, (state, { inputSearch: searchInput }) => ({ ...state, searchInput }))
);

export function OrdersReducer(state: ReducerState, action: Action) {
  return ordersReducer(state, action);
}

export const selectOrdersReducerState = createFeatureSelector<ReducerState>("activeOrders");

// entity selectors
export const { selectAll: selectPPArray } = ppAdapter.getSelectors(selectOrdersReducerState);
export const selectPPEntities = createSelector(selectOrdersReducerState, state => state.entities);

export const getOrdersUi = createSelector(selectOrdersReducerState, ({ ui }) => ui);
export const getSelectedOrder = createSelector(selectOrdersReducerState, ({ selectedOrder }) => selectedOrder);
export const getAllActiveOrders = createSelector(selectOrdersReducerState, ({ activeOrdersList }) => activeOrdersList);
export const getAllArchivedOrders = createSelector(selectOrdersReducerState, ({ archivedOrdersList }) => archivedOrdersList);
export const getOrdersType = createSelector(selectOrdersReducerState, ({ ordersType }) => ordersType);
export const getSearchInput = createSelector(selectOrdersReducerState, ({ searchInput }) => searchInput);
